import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-daterange', 'TODAY', 'Сегодня');
Labels.set('ui-daterange', 'YESTERDAY', 'Вчера');
Labels.set('ui-daterange', 'CURRENT_WEEK', 'Текущая неделя');
Labels.set('ui-daterange', 'CURRENT_MONTH', 'Текущий месяц');
Labels.set('ui-daterange', 'CURRENT_YEAR', 'С начала года');
Labels.set('ui-daterange', 'PREV_YEAR', 'Прошлый год');
Labels.set('ui-daterange', 'PREV_WEEK', 'Предыдущaя неделя');
Labels.set('ui-daterange', 'PREV_MONTH', 'Предыдущий месяц');
Labels.set('ui-daterange', 'PREV_MONTH_TODAY', 'С начала прошлого месяца');
Labels.set('ui-daterange', 'PERIOD_START', 'Начальный период');
Labels.set('ui-daterange', 'PERIOD_END', 'Конечный период');
Labels.set('ui-daterange', 'TIME_START', 'Начальное время');
Labels.set('ui-daterange', 'TIME_END', 'Конечное время');
Labels.set('ui-daterange', 'CHOOSE_DATE_START', 'Выберите дату начала');
Labels.set('ui-daterange', 'CHOOSE_DATE_END', 'Выберите дату окончания');
